import { defineComponent } from "vue";
import camelCase from "./component-library233.mjs";
import pickBy from "./component-library234.mjs";
import mapKeys from "./component-library235.mjs";
import upperFirst from "./component-library236.mjs";
const mapDefaultProps = (original, defaultValues) => {
  Object.keys(defaultValues).forEach((key) => {
    if (original[key] === void 0 || original[key] === null || original[key] === "") {
      original[key] = defaultValues[key];
    }
  });
};
function useMappedPropsOptions(component, prefix, defaultValues = {}) {
  const prefixRegex = new RegExp(`^${prefix}`, "i");
  return defineComponent({
    props: {
      // @ts-ignore
      ...mapKeys(component.props, (_value, key) => `${prefix}${upperFirst(key)}`)
    },
    computed: {
      [`mapped${upperFirst(prefix)}Props`]() {
        const filteredProps = pickBy(this.$props, (_value, key) => key.match(prefixRegex));
        const mappedProps = mapKeys(
          filteredProps,
          (_value, key) => camelCase(key.replace(prefixRegex, ""))
        );
        mapDefaultProps(mappedProps, defaultValues);
        return mappedProps;
      }
    }
  });
}
export {
  useMappedPropsOptions
};
